import React from "react";
import { Facebook, Instagram, Youtube, Twitter } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.4c-1.2.1-2.4-.2-3.5-.8v5.9c0 3-2.2 5.6-5.4 5.6C7.9 20 6 18 6 15.4c0-2.7 2.1-4.8 4.9-4.6v2.5c-.4-.1-.9-.2-1.3-.1-1.2.2-2 1.2-1.9 2.4.1 1.1 1.1 2 2.2 1.9 1.2 0 2.1-1 2.1-2.2V3h2.5z" />
  </svg>
);

const PLATFORMS = [
  { key: "social_facebook", label: "Facebook", Icon: Facebook },
  { key: "social_instagram", label: "Instagram", Icon: Instagram },
  { key: "social_youtube", label: "YouTube", Icon: Youtube },
  { key: "social_tiktok", label: "TikTok", Icon: TikTokIcon },
  { key: "social_x", label: "X", Icon: Twitter },
];

export const SocialLinks = ({ settings, iconClass = "h-5 w-5", className = "" }) => {
  const links = PLATFORMS.filter((p) => (settings?.[p.key] || "").trim());
  if (!links.length) return null;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="social-links">
      {links.map(({ key, label, Icon }) => (
        <a
          key={key}
          href={settings[key]}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`social-${label.toLowerCase()}-link`}
          className="hover:opacity-70 transition-opacity"
        >
          <Icon className={iconClass} />
        </a>
      ))}
    </div>
  );
};
